import { Link } from 'react-router';
import { paths } from '@shared/config/paths';

export function NotFoundPage() {
  return (
    <section className="flex flex-col items-start gap-4">
      <p className="text-sm font-semibold text-indigo-600">404</p>
      <h1 className="text-3xl font-bold tracking-tight">Page introuvable</h1>
      <p className="text-slate-600">La page demandée n'existe pas ou a été déplacée.</p>
      <Link
        to={paths.home}
        className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-indigo-700"
      >
        Retour à l'accueil
      </Link>
    </section>
  );
}
